var _path, _path2, _path3, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnchainLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 7.30005L6 3.30005",
    stroke: "#636366",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 7.1L9.2 9.5",
    stroke: "#636366",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9998 7.1L2.7998 9.5",
    stroke: "#636366",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 1.02856,
    width: 3,
    height: 3,
    rx: 0.5,
    fill: "#636366",
    stroke: "#636366"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 9.02856,
    width: 3,
    height: 3,
    rx: 0.5,
    fill: "#636366",
    stroke: "#636366"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 9.02832,
    width: 3,
    height: 3,
    rx: 0.5,
    fill: "#636366",
    stroke: "#636366"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnchainLight);
export default __webpack_public_path__ + "static/media/onchain_light.4725d9480859127e9219b19756ef6c94.svg";
export { ForwardRef as ReactComponent };